import type * as React from "react";
import { cn } from "../utils/mergeClassNames";

interface IGridProps extends React.HTMLAttributes<HTMLDivElement> {
  id?: string;
  className?: string;
  children: React.ReactNode;
}

const Grid = ({ className, ...props }: IGridProps) => {
  return (
    <div
      className={cn("grid", className)}
      {...props}
    />
  );
};
Grid.displayName = "Grid";

export { Grid };
